<template>
  <div>
    <!-- 搜索符号 -->
    <el-select v-model="judgeSymbol" class="judeg-symbol-container">
      <el-option
        v-for="(key, vlaue) of judgeSymbolOptions"
        :key="key"
        :label="key"
        :value="vlaue"
      />
    </el-select>
    <div
      class="val_container"
      v-show="judgeSymbol !== 'isNull' && judgeSymbol !== 'isNotNull'"
    >
      <!-- 单个时间 -->
      <template v-if="searchType?.type === 'time'">
        <el-date-picker
          v-model="searchVal"
          type="datetime"
          :placeholder="`选择${searchType.label}`"
          format="YYYY/MM/DD hh:mm:ss"
          value-format="YYYY-MM-DD hh:mm:ss"
        />
      </template>
      <!-- 开始结束 -->
      <template v-else-if="searchType?.type === 'date'">
        <el-date-picker
          v-model="searchVal"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="YYYY/MM/DD"
          value-format="YYYY-MM-DD"
          unlink-panels
        />
      </template>
      <!-- 数字 -->
      <template v-else-if="searchType?.propType === 'number'">
        <template
          v-if="judgeSymbol === 'between' || judgeSymbol === 'notBetween'"
        >
          <TwoNumber v-model="searchVal" :search-type="searchType" />
        </template>
        <template v-else>
          <el-input-number
            v-model="searchVal"
            :controls="false"
            :precision="searchType.precision"
            :step="searchType.step"
            :min="searchType.minVal"
            :max="searchType.maxVal"
          />
        </template>
      </template>
      <!-- 字典 -->
      <template
        v-else-if="
          (searchType?.type === 'dict' ||
            searchType?.type === 'dictList' ||
            searchType?.type === 'dictSelect') &&
          !searchType.searchInput
        "
      >
        <el-select
          v-model="searchVal"
          filterable
          clearable
          :placeholder="`选择${searchType.label}`"
        >
          <el-option
            v-for="item in getDictListByParentCode(searchType.dictKey)"
            :key="item.libraryCode"
            :label="item.libraryName"
            :value="item.libraryCode"
          />
        </el-select>
      </template>
      <!-- 仓库 -->
      <template v-else-if="searchType?.type === 'warehouse'">
        <el-select
          v-model="searchVal"
          filterable
          clearable
          :placeholder="`选择${searchType.label}`"
        >
          <el-option
            v-for="subItem in warehouse"
            :key="subItem.warehouseId"
            :label="subItem.warehouseName"
            :value="subItem.warehouseId"
          />
        </el-select>
      </template>
      <template v-else>
        <el-input v-model="searchVal" placeholder="查询条件" clearable />
      </template>
    </div>
  </div>
</template>

<script setup>
import { getDay, isNull } from "@/utils/fangerUtils";
import { computed } from "@vue/reactivity";
import { onMounted, ref, watch } from "vue";
import TwoNumber from "./twoNumber.vue";
import useCacheStore from "@/store/modules/cache";

const cacheStore = useCacheStore();
const { getDictListByParentCode, warehouse } = cacheStore;

const props = defineProps({
  searchType: {
    required: true,
    type: Object,
  },
  modelValue: {
    required: true,
  },
});

const numberJudgeSymbol = {
  eq: "=",
  ne: "!=",
  gt: ">",
  ge: ">=",
  lt: "<",
  le: "<=",
  between: "介于",
  notBetween: "不介于",
  isNull: "为空",
  isNotNull: "不为空",
};

const stringJudgeSymbol = {
  eq: "=",
  like: "包含",
  notLike: "不包含",
  likeRight: "以...开头",
  likeLeft: "以...结尾",
  isNull: "为空",
  isNotNull: "不为空",
};
const judgeSymbolOptions = ref(stringJudgeSymbol);
if (props.searchType.propType === "number") {
  judgeSymbolOptions.value = numberJudgeSymbol;
}

const valWidth = computed(() => {
  if (true) {
    if (judgeSymbol.value === "between" || judgeSymbol.value === "notBetween") {
      return "200px";
    }
    return "200px";
  } else {
    return "250px";
  }
});

const judegSymbolWidth = computed(() => {
  if (true) {
    if (judgeSymbol.value === "isNull" || judgeSymbol.value === "isNotNull") {
      return "200px";
    }
    return "100px";
  } else {
    return "100px";
  }
});

const searchVal = ref("");
const judgeSymbol = ref("eq");

const emits = defineEmits(["update:modelValue"]);

onMounted(() => {
  watch(
    () => props.modelValue,
    (newVal, oldVal) => {
      // 双向绑定的值变化（包含初始值，和每次改变值解析）
      if (!isNull(newVal) && typeof newVal.val === "object") {
        let searchValBack = "";
        if (newVal.val.querLogic === "between") {
          // 查询逻辑介于
          if (props.searchType.type === "date") {
            // 时间
            searchValBack = [
              newVal.val.start.split(" ")[0],
              newVal.val.end.split(" ")[0],
            ];
          } else {
            // 其他
            searchValBack = [newVal.val.start, newVal.val.end];
          }
        } else {
          // 查询逻辑其他
          searchValBack = newVal.val.value;
        }
        if (JSON.stringify(searchVal.value) !== JSON.stringify(searchValBack)) {
          // 判断解决循环赋值，调用
          searchVal.value = searchValBack;
        }
      }
    },
    { immediate: true }
  );
  watch(
    () => props.searchType,
    (newVal) => {
      // 监听类型变化,类型变化，清空值
      if (isNull(newVal)) {
        searchVal.value = "";
        return;
      }
      // 设置默认值
      if (newVal.propType === "number") {
        searchVal.value = 0;
      } else if (newVal.type === "date") {
        searchVal.value = [getDay(-31), getDay(0)];
      } else {
        searchVal.value = "";
      }
      // 设置判断符号
      if (newVal.propType === "number") {
        judgeSymbolOptions.value = numberJudgeSymbol;
        judgeSymbol.value = "eq";
      } else if (newVal.type === "dict" || newVal.type === "warehouse") {
        judgeSymbolOptions.value = { eq: "=" };
        judgeSymbol.value = "eq";
      } else if (newVal.type === "date") {
        judgeSymbolOptions.value = {
          between: "介于",
          notBetween: "不介于",
          isNull: "为空",
          isNotNull: "不为空",
        };
        judgeSymbol.value = "between";
      } else {
        judgeSymbolOptions.value = stringJudgeSymbol;
        judgeSymbol.value = "eq";
      }
    }
  );
  watch([searchVal, judgeSymbol], ([newVal, newVal1], [oldVal]) => {
    // 监听值和符号变化
    let type; // 属性类型
    let val; // 值
    if (props.searchType.type === "date" && newVal instanceof Array) {
      // 时间类型
      type = props.searchType.prop;
      val = {
        column: props.searchType.prop,
        querLogic: "between",
        start: newVal[0] + " 00:00:00",
        end: newVal[1] + " 23:59:59",
      };
    } else {
      type = props.searchType.prop;
      val = {
        column: props.searchType.prop,
        value: newVal,
      };
      if (true) {
        // 查询逻辑符
        val.querLogic = newVal1;
        if (newVal1 === "between" || newVal1 === "notBetween") {
          delete val.value;
          if (typeof newVal === "object") {
            val.start = newVal[0];
            val.end = newVal[1];
          } else {
            val.start = 0;
            val.end = 0;
          }
        } else {
          let _value = newVal;
          if (
            props.searchType.propType === "number" &&
            typeof _value !== "number"
          ) {
            _value = 0;
          }
          if (
            props.searchType.propType !== "number" &&
            typeof _value !== "string"
          ) {
            _value = "";
          }
          val.value = _value;
        }
      } else {
        // 判断有无默认符号
        if (!isNull(props.searchType.defaultQuerLogic)) {
          val.querLogic = props.searchType.defaultQuerLogic;
        } else {
          // 没有默认等于
          val.querLogic = "eq";
        }
      }
    }
    emits("update:modelValue", { type: type, val: val });
  });
});
</script>

<style lang="scss" scoped>
.app-container {
  display: inline-block;
  width: 100%;

  .judeg-symbol-container {
    // position: relative;
    // top: -1px;
    width: v-bind(judegSymbolWidth) !important;

    :deep(.el-input__inner) {
      text-align: center;
      padding: 0px;
      padding-right: 20px;
    }
  }

  // .el-select--small {
  //   width: 250px;
  // }

  // .el-input--small {
  //   width: 250px;
  // }
  .val_container {
    display: inline-block;
    margin-left: 5px;
    // position: relative;
    // top: -34px;

    :deep(.el-date-editor) {
      width: v-bind(valWidth);
      height: 32px;
    }

    :deep(.el-input-number--default) {
      width: v-bind(valWidth);
      height: 32px;
    }

    :deep(.el-input--default) {
      width: v-bind(valWidth);
      height: 32px;
    }

    :deep(.el-select--default) {
      width: v-bind(valWidth);
      height: 32px;
    }
  }
}
</style>
